import { makeStyles } from '@material-ui/core/styles';
import { link } from 'fs';
import { visitEachChild } from 'typescript';
import footer_background from '../../assets/background/footer_background.svg';

export default makeStyles((theme) => ({
    footerContainer: {
        backgroundImage: `url(${footer_background})`,
        backgroundSize: 'cover',
        paddingTop: '250px',
        backgroundRepeat: 'repeat-x',
        width: '100%',
        justifyItems: 'center',
        align: 'center',
        bottom: 0,
        fontFamily: 'Noto Sans JP, sans-serif',
        // padding: '20px auto auto auto',
    },
    footerBox: {
        margin: '0 auto 0 auto',
        padding: '120px 60px 60px 60px',
        textAlign: 'center',
        backgroundColor: 'rgba(255,255,255,0.4)',
        shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        radius: '15px',
        borderRadius: '25px',
        border: '2px solid #FFFFFF',
    },
    boxContainer: {
        justifyItems: 'center',
    },
    signupButton: {
        background: '#F3923D',
        borderRadius: '32.83px',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        marginRight: 25,
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    loginButton: {
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        background: '#FFFFFF',
        border: '1px solid #F3923D',
        borderRadius: '32.83px',
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    appBarSearch: {
        borderRadius: 4,
        marginBottom: '1rem',
        display: 'flex',
        padding: '16px',
    },
    pagination: {
        borderRadius: 4,
        marginTop: '1rem',
        padding: '16px',
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },
    },
    snsLogo: {
        // width: '48.78px',
        // height: '48.78px',
        // backgroundColor: 'rgba(255,255,255,0.4)',
        // border: '2px solid #FFFFFF',
        // boxSizing: 'border-box',
        // boxShadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        // borderRadius: '32.83px',
        display: 'inline-block',
        margin: '30px 15px',
    },
    snsBox: {
        margin: '0 auto 0 auto',
        // padding: '120px 60px 60px 60px',
        textAlign: 'right',
        
        // backgroundColor: 'rgba(255,255,255,0.4)',
        // shadow: 'inset 0px 0px 30px 2px rgba(255, 255, 255, 0.5)',
        // radius: '15px',
        // borderRadius: '25px',
        // border: '2px solid #FFFFFF'
    },
    bottomFooter:{
        color:'white',
        textAlign:'left',
        margin:'150px auto 0 auto',
        paddingBottom:'100px'
    //     a:link {
    //     color: 'white',
    //     backgroundColor: 'transparent',
    //     textDecoration: 'none',
    //   },
        // a:link {color: $Hand3};
        // font-weight: 300;
        // font-family: $secondary-font;
        // a:link {text-decoration:none; background-color:transparent; color: #FAF5F2;};
        // a:visited {text-decoration:none;background-color:transparent; color:#FAF5F2;};
        // a:hover {text-decoration:none;background-color:transparent; color:#FAF5F2;};
        // a:active {text-decoration:none;background-color:transparent; color:#FAF5F2;};
        // color: $Hand3;
    },
    link: {
        color: 'white', 
        textDecoration: 'none',
        // color: "#00ff00",
        "&:hover": {
            color: "white",
            // textDecoration: "underline",
            opacity:0.7
        }
    },

    // a:link : {
    //     color: 'white',
    //     backgroundColor: 'transparent',
    //     textDecoration: 'none',
    //   },
      
    //   a:visitEachChild {
    //     color: 'white',
    //     backgroundColor: transparent,
    //     text-decoration: none,
    //   },
      
    //   a:hover {
    //     color: 'white',
    //     backgroundColor: transparent,
    //     text-decoration: underline,
    //   },
      
    //   a:active {
    //     color: 'white',
    //     backgroundColor: transparent,
    //     text-decoration: underline,
    //   }
}));